module.exports = __webpack_public_path__ + "img/8C5945_D4C0B6_C3A49C_430504-256px.8e83d9ca.png";